module.exports = __webpack_public_path__ + "public/images/profile-avatar.175afb8309ad736b77d681b86212c9ec.svg";